import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62754540"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "importModal__stepOne"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "下载模板", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "下载模板，填写员工基本信", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "上传导入文件", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "上传导入文件", -1))
const _hoisted_6 = { class: "importModal__upload" }
const _hoisted_7 = ["disabled", "value"]
const _hoisted_8 = {
  key: 1,
  class: "importModal__stepTwo"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "导入完成", -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "text-primary" }
const _hoisted_12 = { class: "text-error" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "导入中, 请稍候", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    class: _normalizeClass(["importModal", {noClose: _ctx.uploading}]),
    title: "批量导入员工",
    width: 600,
    footer: null,
    onCancel: _ctx.onCancel
  }, {
    default: _withCtx(() => [
      (_ctx.step === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _hoisted_2,
              _hoisted_3,
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onDownload(0)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 下载模版 ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", null, [
              _hoisted_4,
              _hoisted_5,
              _withDirectives(_createElementVNode("div", _hoisted_6, [
                _createVNode(_component_a_button, { type: "primary" }, {
                  default: _withCtx(() => [
                    _createTextVNode("上传文件")
                  ]),
                  _: 1
                }),
                _createElementVNode("input", {
                  type: "file",
                  accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/octet-stream",
                  disabled: _ctx.uploading,
                  value: _ctx.formData.file,
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onUpload($event)))
                }, null, 40, _hoisted_7)
              ], 512), [
                [_vShow, !_ctx.uploadComplete]
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (!_ctx.uploading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_9,
                  (!_ctx.uploading)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                        _createTextVNode("结果: 成功 ("),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.uploadRes.success), 1),
                        _createTextVNode(") 条, 失败 ("),
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.uploadRes.fail), 1),
                        _createTextVNode(") 条。")
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.uploadRes.fail)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        type: "primary",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onDownload(1, _ctx.uploadRes.importFailKey)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("下载并修改")
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_a_button, {
                        key: 2,
                        type: "primary",
                        onClick: _ctx.onComfirm
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("确定")
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_a_spin),
                  _hoisted_13
                ], 64))
          ]))
    ]),
    _: 1
  }, 8, ["visible", "class", "onCancel"]))
}